<div fxLayout="column" fxLayoutAlign="center center" class="layout-padd" fxFlexFill>

  <span class="mat-headline text-center" ngClass.xs="mat-title">{{"disabledOrder"|translate}}</span>
</div>